
export class SaveDataResult<T = any> {
    constructor(public ok = false, public data: T = null) { 
    }
}